import type { TTransactionType, TTransactionStatus } from '../../store/types';

export const transactionsTypes: TTransactionType[] = [
  'deposit',
  'withdrawal',
  'withdrawal_cancel',
  'deposit_cancel',
  'partner_commission',
  'partner_commission_cancel',
];

export const transactionsTypeTitles: Record<TTransactionType, string> = {
  deposit: 'Пополнение',
  withdrawal: 'Вывод средств',
  withdrawal_cancel: 'Отмена вывода',
  deposit_cancel: 'Отмена пополнения',
  partner_commission: 'Партнёрская комиссия',
  partner_commission_cancel: 'Отмена партнёрской комиссии',
};

export const transactionsStatuses: TTransactionStatus[] = ['pending', 'approved', 'declined', 'in_progress'];

export const transactionsStatusTitles: Record<TTransactionStatus, string> = {
  pending: 'В ожидании',
  approved: 'Одобрено',
  declined: 'Отклонено',
  in_progress: 'Взять в работу',
};
